export default __webpack_public_path__ + "dist/media/download-nda.6a5e5c94.svg";